import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-rating',
  standalone: true,
  templateUrl: './rating.component.html',
  styleUrl: './rating.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RatingComponent),
      multi: true,
    },
  ],
})
export class RatingComponent implements ControlValueAccessor {
  @Input({ required: true }) name!: string;

  public stars = [1, 2, 3, 4];
  public value: number = 0;
  public hoveredValue: number | null = null;

  private onChange = (val: number) => {};
  private onTouched = () => {};

  public selectStar(val: number): void {
    this.value = val;
    this.onChange(val);
    this.onTouched();
  }

  public setHover(value: number | null): void {
    this.hoveredValue = value;
  }

  writeValue(val: number): void {
    this.value = val || 0;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
